export default {
    accessibility_baseline: 'common/accessibility_baseline',
    accordion: 'special/accordion',
    account: 'common/account',
    account_balance_outline: 'common/account_balance_outline',
    account_circle: 'common/account_circle',
    align_horizontal_center_baseline: 'common/align_horizontal_center_baseline',
    align_horizontal_left_baseline: 'common/align_horizontal_left_baseline',
    align_vertical_top_baseline: 'common/align_vertical_top_baseline',
    apps: 'common/apps',
    arrow_back: 'common/arrow_back',
    arrow_down: 'common/arrow_down',
    arrow_forward: 'common/arrow_forward',
    arrow_left_outline: 'common/arrow_left_outline',
    arrow_right: 'common/arrow_right',
    assignment: 'special/assignment',
    attachment: 'common/attachment',
    bar_chart: 'common/bar_chart',
    bookmark: 'common/bookmark',
    business: 'special/business',
    calendar: 'common/calendar',
    cancel: 'common/cancel',
    check: 'common/check',
    check_circle: 'common/check_circle',
    check_circle_outline: 'common/check_circle_outline',
    check_outline: 'common/check_outline',
    chevron_left_baseline: 'common/chevron_left_baseline',
    chevron_right_baseline: 'common/chevron_right_baseline',
    clock_outline: 'common/clock_outline',
    close: 'common/close',
    close_circle: 'common/close_circle',
    close_outline: 'common/close_outline',
    cloud: 'common/cloud',
    cloud_download_outline: 'common/cloud_download_outline',
    cms: 'special/cms',
    code: 'common/code',
    column: 'common/column',
    commit: 'common/commit',
    copy: 'common/copy',
    csv_file: 'common/csv_file',
    darkmode_theme: 'common/darkmode-theme',
    dashboard: 'special/dashboard',
    dashboards_list: 'special/dashboards-list',
    delete: 'common/delete',
    delete_outline: 'common/delete_outline',
    dissatisfied: 'common/dissatisfied',
    dot: 'common/dot',
    download: 'common/download',
    download_outline: 'common/download_outline',
    drag_indicator: 'common/drag_indicator',
    edit: 'common/edit',
    equally: 'common/equally',
    exit: 'common/exit',
    facebook: 'special/facebook',
    file: 'common/file',
    filters_list: 'common/filters_list',
    flip_to_front: 'common/flip-to-front',
    folder: 'special/folder',
    group: 'special/group',
    groups_outline: 'common/groups_outline',
    grid_view: 'common/grid_view',
    help_outline: 'common/help_outline',
    history: 'common/history',
    holiday_village_outline: 'common/holiday_village_outline',
    home: 'common/home',
    home_fill: 'common/home_fill',
    home_outline: 'common/home_outline',
    image: 'common/image',
    info: 'common/info',
    info_outline: 'common/infoOutline',
    insert_comment_outline: 'common/insert_comment_outline',
    kebab: 'common/kebab',
    keyboard_arrow_down: 'common/keyboard_arrow_down',
    lan_outline: 'common/lan_outline',
    laptop: 'common/laptop-bp',
    linkedin: 'special/linkedin',
    list_alt: 'common/list_alt',
    list_outline: 'common/list_outline',
    loading: 'common/loading',
    location_on_outline: 'common/location_on_outline',
    lock_outline: 'common/lock_outline',
    mail: 'common/mail',
    mail_outline: 'common/mail_outline',
    map: 'common/map_outline',
    menu: 'common/menu',
    message_1: 'common/message_1',
    message_2: 'common/message_2',
    message_3: 'common/message_3',
    minus: 'common/minus',
    mobile_phone: 'common/phone-bp',
    monetization: 'common/monetization',
    monetization_on_outline: 'common/monetization_on_outline',
    notification_outline: 'common/notification_outline',
    notifications: 'common/notifications',
    notifications_fill: 'special/notifications_fill',
    open_in_new: 'common/open_in_new',
    open_sidebar: 'common/open_sidebar',
    page_view: 'common/page_view',
    pdf: 'common/pdf',
    person_outline: 'common/person_outline',
    phone: 'common/phone',
    pin_outline: 'common/pin_outline',
    plus: 'common/plus',
    power: 'common/power',
    reload: 'common/reload',
    remove: 'common/remove',
    replay: 'common/replay',
    request_page_outline: 'common/request_page_outline',
    rocket: 'common/rocket',
    search: 'common/search',
    search_off: 'common/search_off',
    settings_fill: 'special/settings_fill',
    settings_outline: 'common/settings_outline',
    shiny_stars: 'common/shiny_stars',
    shopping_cart: 'common/shopping_cart',
    sort: 'special/sort',
    spinner: 'common/spinner',
    star: 'common/star',
    star_outline: 'common/star_outline',
    sticky_note: 'common/sticky_note',
    switch_account_outline: 'common/switch_account_outline',
    tablet: 'common/tablet-bp',
    tag: 'common/tag',
    trending_up_outline: 'common/trending_up_outline',
    tune: 'common/tune',
    tv: 'common/tv-bp',
    twitter: 'special/twitter',
    unfold_less: 'common/unfold_less',
    unfold_more: 'common/unfold_more',
    upload: 'common/upload',
    verified_user_outline: 'common/verified_user_outline',
    vertical_align_center_baseline: 'common/vertical_align_center_baseline',
    view_agenda: 'common/view_agenda',
    visibility: 'common/visibility',
    visibility_off: 'common/visibility_off',
    warning_amber: 'common/warning_amber',
    where_to_vote_outline: 'common/where_to_vote_outline',
    widgets_outline: 'common/widgets_outline',
    workspaces_outline: 'common/workspaces_outline'
};
